import { useMemo } from 'react';
import { usePermission } from './usePermission';
import { INVENTORY_PERMISSIONS } from '../constants/permissions.constants';

/**
 * KPI visibility for Inventario general (granular flags under inventory-general menu).
 */
export const useInventoryGeneralKPIPermissions = () => {
  const canKpiTotalProducts = usePermission(INVENTORY_PERMISSIONS.GENERAL.KPI_TOTAL_PRODUCTS);
  const canKpiTotalSaleValue = usePermission(INVENTORY_PERMISSIONS.GENERAL.KPI_TOTAL_SALE_VALUE);
  const canKpiTotalCostValue = usePermission(INVENTORY_PERMISSIONS.GENERAL.KPI_TOTAL_COST_VALUE);
  const canKpiUnassigned = usePermission(INVENTORY_PERMISSIONS.GENERAL.KPI_UNASSIGNED);
  const canKpiAssigned = usePermission(INVENTORY_PERMISSIONS.GENERAL.KPI_ASSIGNED);
  const canKpiInTransit = usePermission(INVENTORY_PERMISSIONS.GENERAL.KPI_IN_TRANSIT);
  const canKpiBajas = usePermission(INVENTORY_PERMISSIONS.GENERAL.KPI_BAJAS);
  const canKpiCatalogProductTotal = usePermission(
    INVENTORY_PERMISSIONS.GENERAL.KPI_CATALOG_PRODUCT_TOTAL,
  );

  return useMemo(
    () => ({
      canKpiTotalProducts,
      canKpiTotalSaleValue,
      canKpiTotalCostValue,
      canKpiUnassigned,
      canKpiAssigned,
      canKpiInTransit,
      canKpiBajas,
      canKpiCatalogProductTotal,
    }),
    [
      canKpiTotalProducts,
      canKpiTotalSaleValue,
      canKpiTotalCostValue,
      canKpiUnassigned,
      canKpiAssigned,
      canKpiInTransit,
      canKpiBajas,
      canKpiCatalogProductTotal,
    ],
  );
};
